export const sendBulkEmail = async (token, userId, payload) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const body = { user_id: userId, ...payload };
  if (!body.member_ids || body.member_ids.length === 0) delete body.member_ids;

  const response = await fetch(`${window.constants.api_url}/bulk-email`, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(body),
    redirect: "follow",
  });
  return response.json();
};

export const sendBulkHolidayWhatsapp = async (token, userId, payload) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  const raw = JSON.stringify({
    user_id: userId,
    ...payload,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  const response = await fetch(
    `${window.constants.api_url}/bulk-holiday-whatsapp`,
    requestOptions
  );
  return response.json();
};
